import PlayStoreWhiteLogo from "@/components/data-display/logo/PlayStoreWhite";
import AppStoreWhiteLogo from "@/components/data-display/logo/AppStoreWhite";
import AmarPetWhiteLogo from "@/components/petTag/AmarPetWhiteLogo";
import { contactInfo } from "@/utils/constants/supportInfo";
import {
  EmailFilledIcon,
  FacebookWhiteIcon,
  InstagramWhiteIcon,
  LocationFilledIcon,
  PhoneFilledIcon,
} from "@/components/data-display/Icon";
import { socialMediaPagesLink } from "@/utils/constants/supportInfo";
import { MOBILE_APP_LINK } from "@/utils/constants/mobileAppLink";

import Link from "next/link";

function PetTagFooter() {
  return (
    <div className="bg-[#1B005F] ">
      <div className="flex px-7 lg:px-[7.5rem]">
        <div className="w-full min-h-[21.125rem]">
          <div className="mt-[7.563rem] mb-[4rem] flex flex-col md:flex-row justify-between space-y-[44px] md:space-y-0">
            <div className="space-y-[1.5rem] md:w-[35%]">
              <AmarPetWhiteLogo />
              <p className=" text-[#CCC] text-sm font-normal leading-[22px] max-w-[296px]">
                Made with ❤️ from Dhaka, our only goal is the welfare of your
                beloved pet. We are and will be always there for you.
              </p>

              <div className=" flex items-center space-x-[8px]">
                <PlayStoreWhiteLogo redirectUrl={MOBILE_APP_LINK.play_store} />

                <AppStoreWhiteLogo redirectUrl={MOBILE_APP_LINK.app_store} />
              </div>
            </div>

            <section className="text-[#FFF] md:w-[65%] grid gap-[2rem] lg:gap-0  md:grid-cols-4">
              <div className=" space-y-[2.125rem]">
                <h3 className="text-lg font-semibold">About</h3>
                <ul className=" text-sm font-normal space-y-[1.125rem]">
                  <li>
                    <Link href="/contact-us">Contact Us</Link>
                  </li>
                  <li>
                    <Link href="/about-us">About Us</Link>{" "}
                  </li>
                  <li>
                    <Link href="/blogs">Blog</Link>
                  </li>
                  <li>
                    <Link href="/faq"> FAQs</Link>
                  </li>
                </ul>
              </div>

              <div className=" space-y-[2.125rem]">
                <h3 className="text-lg font-semibold">Service</h3>
                <ul className=" text-sm font-normal space-y-[1.125rem]">
                  <li>
                    <Link href="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link href="/terms-of-use">Terms of Use</Link>
                  </li>
                  <li>
                    <Link href="/return-and-refund-policy">
                      Return & Refund Policy
                    </Link>
                  </li>
                </ul>
              </div>

              <div className=" space-y-[2.125rem]">
                <h3 className="text-lg font-semibold">Contact</h3>
                <ul className=" text-sm font-normal space-y-[1.125rem]">
                  <li>
                    <div className="flex items-center space-x-[1rem]">
                      <PhoneFilledIcon />
                      <Link href={"tel:" + contactInfo.phone1}>
                        {contactInfo.phone1}
                      </Link>
                    </div>
                  </li>

                  <li>
                    <div className="flex items-center space-x-[1rem]">
                      <EmailFilledIcon className=" shrink-0" />

                      <Link href={"mailto:" + contactInfo.email}>
                        {contactInfo.email}
                      </Link>
                    </div>
                  </li>

                  <li>
                    <div className="flex items-start space-x-[1rem] ml-[6px] w-full">
                      <LocationFilledIcon className="shrink-0" />

                      <div className="max-w-[164px]">
                        Zakir Complex (9th Floor), Ka-218, Kuril Chowrasta,
                        Dhaka-1229, Bangladesh.
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="space-y-[2.125rem] md:mx-auto ">
                <h3 className="text-lg font-semibold">Social media</h3>
                <ul className=" flex space-x-[1.688rem] items-center">
                  <a
                    href={socialMediaPagesLink.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FacebookWhiteIcon />
                  </a>

                  {/* <TwitterWhiteIcon />

                  <LinkedinWhiteIcon /> */}

                  <a
                    href={socialMediaPagesLink.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <InstagramWhiteIcon />
                  </a>
                </ul>
              </div>
            </section>
          </div>
        </div>
      </div>
      <hr className=" h-[1px] bg-white opacity-25" />
      <div className="text-xs font-light text-white text-center py-4">
        <p>
          <span className="font-semibold">AmarPet.com</span>
          <span>©&nbsp;2024&nbsp;All Rights&nbsp;</span>
          Reserved
        </p>
      </div>
    </div>
  );
}

export default PetTagFooter;
